import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _excluded = ["eventAction", "eventCategory", "eventLabel"];
import BySubject from './bySubject';

var ByDataLayer = /*#__PURE__*/function (_BySubject) {
  _inherits(ByDataLayer, _BySubject);

  var _super = _createSuper(ByDataLayer);

  function ByDataLayer() {
    _classCallCheck(this, ByDataLayer);

    return _super.apply(this, arguments);
  }

  _createClass(ByDataLayer, [{
    key: "execute",
    value: function execute() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.proxyDataLayerPush();
      this.opts = opts;
    } // 重写 push

  }, {
    key: "proxyDataLayerPush",
    value: function proxyDataLayerPush() {
      var _this = this;

      window.dataLayer = window.dataLayer || [];
      var gaPush = window.dataLayer.push.bind(window.dataLayer);

      window.dataLayer.push = function (_ref) {
        var eventAction = _ref.eventAction,
            eventCategory = _ref.eventCategory,
            eventLabel = _ref.eventLabel,
            other = _objectWithoutProperties(_ref, _excluded);

        if (eventAction) {
          _this.notifyObservers(_objectSpread({
            action: eventAction,
            category: eventCategory,
            label: eventLabel,
            dt: undefined,
            duration: other.duration
          }, _this.opts));
        }

        gaPush(_objectSpread({
          event: 'GAEvent',
          eventAction: eventAction,
          eventCategory: eventCategory,
          eventLabel: eventLabel
        }, other));
      };
    }
  }]);

  return ByDataLayer;
}(BySubject);

export { ByDataLayer as default };